<template>
  <div>
    <p
      v-if="
        project.type != 'Distributor' &&
          product.productData.productType != 'Custom Tag'
      "
    >
      {{ swatchMessage }}
    </p>
    <div
      v-if="pricingInformation"
      v-html="pricingInformation && formatContent(pricingInformation)"
    />

    <div class="uk-overflow-auto">
      <table class="uk-table uk-table-small uk-table-divider">
        <thead>
          <tr>
            <th>Quantity</th>
            <th v-if="!data.customPricing">
              <span v-if="project.type == 'Distributor'">Net </span>Price
            </th>
            <template v-else>
              <th v-for="heading in productHeadings" :key="heading.name">
                {{ heading.name }}
              </th>
            </template>
          </tr>
        </thead>
        <tbody v-if="data.customPricing">
          <tr
            v-for="tier in standardPricing[
              _.camelCase(product.productData.productType)
            ]"
            :key="tier.index"
          >
            <td>
              <template
                v-if="tier.min == tier.max || (tier.min == 0 && tier.max == 1)"
                >{{ tier.max }}</template
              >
              <template v-else>
                {{ tier.min | quantity }}<span v-if="tier.max < 9999">-</span
                >{{ tier.max | quantity }}</template
              >
            </td>
            <td v-for="heading in productHeadings" :key="heading.name">
              {{ tier.price[heading.firebaseId] | money }} each
            </td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr v-for="tier in productPricing" :key="tier.index">
            <td v-if="product.productData.productType == 'Table Runner'">
              <template
                v-if="tier.min == tier.max || (tier.min == 0 && tier.max == 1)"
              >
                {{ tier.min | quantity }}
              </template>
              <template v-else
                >{{ tier.min | quantity }}<span v-if="tier.max < 9999">-</span
                >{{ tier.max | quantity }}
              </template>
            </td>
            <td v-else>
              {{ tier.min | quantity }}<span v-if="tier.max < 9999">-</span
              >{{ tier.max | quantity }}
            </td>
            <template v-if="product.productData.productType == 'Chiffon Scarf'">
              <td>
                <span>{{ tier.price.square | money }}</span>
              </td>
              <td>
                <span>{{ tier.price.smallRectangle | money }}</span>
              </td>
              <td>
                <span>{{ tier.price.mediumRectangle | money }}</span>
              </td>
              <td>
                <span>{{ tier.price.largeRectangle | money }}</span>
              </td>
            </template>
            <template
              v-else-if="product.productData.productType == 'Table Runner'"
            >
              <td>
                <span>{{ tier.price['12"x72"'] | money }}</span>
              </td>
              <td>
                <span>{{ tier.price['12"x96"'] | money }}</span>
              </td>
              <td>
                <span>{{ tier.price['12"x120"'] | money }}</span>
              </td>
              <td>
                <span>{{ tier.price['12"x144"'] | money }}</span>
              </td>
            </template>
            <td v-else>{{ tier.price | money }} each</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import _ from "lodash";

export default {
  name: "Pricing",
  filters: {
    money: function(value) {
      return "$" + Number(value).toFixed(2);
    },
    quantity: function(value) {
      if (value == "0") {
        return "1";
      } else if (value > 9998) {
        return "+";
      } else {
        return value;
      }
    }
  },
  props: {
    product: { type: Object, required: true },
    selectedOption: { type: Object, required: true },
    project: { type: Object, required: true },
    standardPricing: { type: Object, required: true },
    swatchMessage: { type: String, required: false, default: null },
    pricingInformation: { type: Object, required: false, default: null },
    data: { type: Object, required: true, default: null }
  },
  data() {
    return {};
  },
  computed: {
    productHeadings() {
      if (this.data.customPricing) {
        if (this.data.friendlyOptionNames) {
          const friendlyNames = this.data.friendlyOptionNames.map(name => {
            name = name.split(":");
            return { firebaseId: name[0], name: name[1] };
          });
          return friendlyNames;
        } else {
          return this.data.variantMapping;
        }
      }
      return [];
    },
    productPricing() {
      if (this.product.productData.productType == "Custom Tag") {
        return this.standardPricing.customTags;
      } else {
        return this.standardPricing[
          _.camelCase(this.product.productData.productType)
        ];
      }
    }
  },
  mounted() {},
  methods: {
    formatContent(content) {
      var newContent = document.createElement("div");
      for (const block of content.json.content) {
        if (block.nodeType == "paragraph") {
          let text = document.createElement("p");
          for (content in block.content) {
            text.innerHTML += block.content[content].value.replaceAll(
              "\n",
              "<br />"
            );
          }

          newContent.appendChild(text);
        }
        if (block.nodeType == "text") {
          let text = document.createElement("span");
          text.innerText = block.value;
          newContent.appendChild(text);
        }
      }
      return newContent.innerHTML;
    }
  }
};
</script>

<style type="text/css"></style>



// WEBPACK FOOTER //
// src/components/design-portal/Pricing.vue